import { IActionResponse, IActionResult, BaseClient } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { LookupDto, RoleClaimDto } from "../../dto";

export class RoleClaimClient extends BaseClient {
    routes = ["account", "Role"];

    async getRoleClaimsAsync(roleId?: string | undefined): Promise<RoleClaimDto> {
        const actions: string[] = ["GetRoleClaims"];
        const params: ApiParams[] = [new ApiParams("roleId", roleId, true)];

        const result: RoleClaimDto = await this.getAsync<RoleClaimDto>(actions, params);
        return result;
    }

    async getLookupsAsync(): Promise<{ permission: LookupDto[]; role: LookupDto[]; }> {
        const actions: string[] = ["GetRoleClaimLookups"];
        const result = await this.getAsync<{ permission: LookupDto[]; role: LookupDto[]; }>(actions, []);
        return result;
    }

    async saveRoleClaimAsync( payload?: RoleClaimDto | undefined ): Promise<IActionResult<RoleClaimDto>> {
        const actions: string[] = ["SaveRoleClaim"];
        return await this.postAsync<RoleClaimDto>(actions, payload);
    }

    async deleteRoleClaimAsync( id?: number | undefined ): Promise<IActionResponse> {
        const actions: string[] = ["DeleteRoleClaim"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        return await this.deleteAsync(actions, params);
    }
}
